import { Chain } from "viem"

export const bobaAvax = {
  id: 43288,
  name: "Boba-Avax L2",
  nativeCurrency: {
    decimals: 18,
    name: "Boba",
    symbol: "BOBA",
  },
  rpcUrls: {
    default: { http: ["https://avax.boba.network"] },
    public: { http: ["https://avax.boba.network"] },
  },
  blockExplorers: {
    default: {
      name: "BlockScout",
      url: "https://blockexplorer.avax.boba.network",
    },
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 94846,
    },
  },
} as const satisfies Chain

export const exosama = {
  id: 2109,
  name: "Exosama",
  nativeCurrency: {
    decimals: 18,
    name: "Moonsama",
    symbol: "SAMA",
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.exosama.com"],
    },
    public: {
      http: ["https://rpc.exosama.com"],
    },
  },
  blockExplorers: {
    default: {
      name: "BlockScout",
      url: "https://explorer.exosama.com",
    },
  },
} as const satisfies Chain

export const scrollAlpha = {
  id: 534353,
  name: "Scroll Alpha",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH",
  },
  rpcUrls: {
    default: {
      http: ["https://alpha-rpc.scroll.io/l2"],
    },
    public: {
      http: ["https://alpha-rpc.scroll.io/l2"],
    },
  },
  blockExplorers: {
    default: {
      name: "BlockScout",
      url: "https://alpha-blockscout.scroll.io",
    },
  },
  contracts: {
    multicall3: {
      address: "0xd152cd6f9cf76921759d3f51f743651e549f6925",
      blockCreated: 47009,
    },
  },
} as const satisfies Chain

export const bitfinityTestnet = {
  id: 355113,
  name: "Bitfinity Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Bitfinity",
    symbol: "BFT",
  },
  rpcUrls: {
    default: {
      http: ["https://testnet.bitfinity.network"],
    },
    public: {
      http: ["https://testnet.bitfinity.network"],
    },
  },
  blockExplorers: {
    default: {
      name: "Bitfinity",
      url: "https://explorer.bitfinity.network",
    },
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 7032,
    },
  },
} as const satisfies Chain

export const ontology = {
  id: 58,
  name: "Ontology EVM",
  nativeCurrency: {
    decimals: 18,
    name: "ONG",
    symbol: "ONG",
  },
  rpcUrls: {
    default: {
      http: [
        "https://dappnode1.ont.io:10339",
        "https://dappnode2.ont.io:10339",
        "https://dappnode3.ont.io:10339",
        "https://dappnode4.ont.io:10339",
      ],
    },
    public: {
      http: [
        "https://dappnode1.ont.io:10339",
        "https://dappnode2.ont.io:10339",
        "https://dappnode3.ont.io:10339",
        "https://dappnode4.ont.io:10339",
      ],
    },
  },
  blockExplorers: {
    default: {
      name: "Ontology",
      url: "https://explorer.ont.io",
    },
  },
  contracts: {
    multicall3: {
      address: "0xce6292279bf688173b269df080e14407470a9e60",
      blockCreated: 14244158,
    },
  },
} as const satisfies Chain

export const beraTestnet = {
  id: 2061,
  name: "Berachain Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "BERA",
    symbol: "BERA",
  },
  rpcUrls: {
    default: {
      http: ["https://artio.rpc.berachain.com"],
    },
    public: {
      http: ["https://artio.rpc.berachain.com"],
    },
  },
  blockExplorers: {
    default: {
      name: "Beratrail",
      url: "https://artio.beratrail.io",
    },
  },
  contracts: {
    multicall3: {
      address: "0x5406b58D03A99c7E7Ac3d59957A2822CffB8Bb34",
      blockCreated: 114673,
    },
  },
} as const satisfies Chain

export const taikoKatlaTestnet = {
  id: 167008,
  name: "Taiko Katla Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH",
  },
  rpcUrls: {
    default: {
      http: ["https://taiko-katla.blockpi.network/v1/rpc/public"],
    },
    public: {
      http: ["https://taiko-katla.blockpi.network/v1/rpc/public"],
    },
  },
  blockExplorers: {
    default: {
      name: "BlockScout",
      url: "https://explorer.katla.taiko.xyz",
    },
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 77870,
    },
  },
} as const satisfies Chain

export const oasisSapphire = {
  id: 23294,
  name: "Oasis Sapphire",
  nativeCurrency: {
    name: "Rose",
    symbol: "ROSE",
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ["https://sapphire.oasis.io"],
    },
    public: {
      http: ["https://sapphire.oasis.io"],
    },
  },
  blockExplorers: {
    default: {
      name: "BlockScout",
      url: "https://explorer.sapphire.oasis.io",
    },
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 734531,
    },
  },
} as const satisfies Chain

export const mint = {
  id: 185,
  name: "Mint",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH",
  },
  rpcUrls: {
    default: { http: ["https://rpc.mintchain.io"] },
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://explorer.mintchain.io/",
    },
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 2239893,
    },
  },
  testnet: false,
} as const satisfies Chain

export const zero = {
  id: 543210,
  name: "Zero",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH",
  },
  rpcUrls: {
    default: { http: ["https://rpc.zerion.io/v1/zero"] },
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://explorer.zero.network",
    },
  },
  contracts: {
    multicall3: {
      address: "0x0307F341a18f1FC1f63a7Ceeac970245A08C5a80",
      blockCreated: 11517,
    },
  },
  testnet: false,
} as const satisfies Chain
